const { UNITS } = require('../constants');
const { RGX } = require('./constants');

/**
 * Converts letter spacing  value in px into rounded value in em
 * @param {String | Number} letterSpacing
 * @param {String | Number} fontSize
 * @param {Number} precision
 * @returns {Number}
 */
const convertLetterSpacingToEm = (letterSpacing = 0, fontSize, precision) => {
    const result = RGX.exec(letterSpacing.toString());
    let value = (result && result[1]) ? parseFloat(result[1]) : 0;
    const unit = result && result[2];
    if (unit !== UNITS.EM) {
        value = value / parseFloat(fontSize);
    }
    if (precision) {
        const mult = 1 / precision;
        value = Math.round(value * mult) / mult;
    }
    if (Number.isNaN(value)) {
        value = 0;
    }
    return value;
};

module.exports = convertLetterSpacingToEm;
